<template>
  <teleport to="body">
    <!--
      UN BANDEAU QU'ON NE PEUT PAS MANQUER.
      Il occupait auparavant une petite pastille flottante, discrète au point
      qu'on pouvait explorer l'outil sans se rendre compte qu'on lisait des
      données de test — et s'étonner ensuite de ne pas les retrouver. Le voici
      sur TOUTE la largeur, en ambre, avec des rayures qui défilent lentement :
      le mouvement est ce qui capte l'œil, une couleur seule se fond au bout de
      deux minutes.
    -->
    <div
      v-if="discovery.active"
      class="pa-discovery-band fixed inset-x-0 bottom-0 z-[55] border-t-2 border-sunflower-gold/70"
      role="status"
      aria-live="polite"
    >
      <div class="mx-auto flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-2 px-4 py-2.5">
        <span class="flex min-w-0 items-center gap-2.5">
          <!-- La pastille bat : sur un écran figé, c'est elle qui dit que le
               bandeau parle de MAINTENANT et non d'un message oublié là. -->
          <span class="pa-discovery-dot" aria-hidden="true" />
          <span class="min-w-0">
            <span class="block text-sm font-semibold text-space-indigo">
              Mode découverte — vous regardez des données de test
            </span>
            <span class="block text-xs text-space-indigo/80">
              Rien de ce que vous faites ici n'atteint les vraies données, et personne d'autre ne
              le voit.
            </span>
          </span>
        </span>

        <div class="ml-auto flex shrink-0 items-center gap-2">
          <button
            type="button"
            class="rounded-lg px-3 py-1.5 text-sm font-medium text-space-indigo transition-colors hover:bg-space-indigo/10 disabled:opacity-50"
            :disabled="resetting"
            @click="onReset"
          >
            {{ resetting ? 'Remise à zéro…' : 'Réinitialiser' }}
          </button>
          <button
            type="button"
            class="rounded-lg bg-space-indigo px-3 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-space-indigo/90"
            @click="onExit"
          >
            Quitter la découverte
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useDiscoveryStore } from '@/stores/discovery';
import { resetSandbox, exitDiscovery } from '@/lib/discovery';

const discovery = useDiscoveryStore();
const router = useRouter();
const resetting = ref(false);

/*
 * Le bandeau est FIXE : sans compensation, il masquerait le bas de chaque page —
 * le dernier point d'une liste, le bouton d'un formulaire. La classe posée sur
 * `body` réserve la hauteur, et disparaît avec le mode.
 */
const CLASSE = 'pa-discovery-on';
watch(
  () => discovery.active,
  (actif) => document.body.classList.toggle(CLASSE, actif),
  { immediate: true },
);
onBeforeUnmount(() => document.body.classList.remove(CLASSE));

async function onReset(): Promise<void> {
  if (resetting.value) return;
  resetting.value = true;
  try {
    await resetSandbox();
    // Recharge la vue courante pour refléter le bac à sable remis à neuf.
    router.go(0);
  } finally {
    resetting.value = false;
  }
}

function onExit(): void {
  exitDiscovery();
  void router.push('/');
}
</script>
